import { useMemo } from "react"

import { Flex, Typography } from "antd"
import classname from "classname"

import Private from "../../../../../../Components/Private"
import AppUtils from "../../../../../../Utils/utils"
import { getMonitoringMonthIcon } from "../../../utils/getMonitoringMonthIcon"
import MonthStatus from "../MonthStatus/MonthStatus"

import "./MonthBlock.less"

const { Text } = Typography

const MonthBlock = ({ data, currentMonth, styles, isMobile = false }) => {
  const { icon, variant } = useMemo(() => getMonitoringMonthIcon(data.icon, data.status), [data])

  if (isMobile) {
    return (
      <Flex
        className={classname("bh-monitoring-month-block", "is-mobile", variant)}
        style={styles}
        vertical
        gap={8}
      >
        <Flex align="center" gap={8}>
          <MonthStatus icon={icon} variant={variant} />
          <Text className="month-title">{data.month_name}</Text>
        </Flex>
        <Flex vertical gap={2} className="month-metrics">
          <Text type="secondary">
            <span className={classname("text-number", variant)}>
              <Private>{`${data.vamp_rate ?? 0}%`}</Private>
            </span>
          </Text>
          <Text type="secondary">
            <span className={classname("text-number", variant)}>
              {AppUtils.convertNumber(data.dispute_count, 1)}
            </span>{" "}
            disputes
          </Text>
          <Text type="secondary">
            <span className={classname("text-number", variant)}>
              {AppUtils.convertNumber(data.transaction_count, 1)}
            </span>{" "}
            payments
          </Text>
        </Flex>
      </Flex>
    )
  }

  return (
    <Flex className="bh-monitoring-month-block" style={styles} vertical align="center" gap={8}>
      <MonthStatus icon={icon} variant={variant} />
      <div
        className={classname("month-name", {
          current: data.month === currentMonth
        })}
      >
        <Text type="secondary">{data.month_name}</Text>
      </div>
      <Flex vertical align="center" gap={2}>
        <Text type="secondary" className={classname("text-number", variant)}>
          <Private>{`${data.vamp_rate ?? 0}%`}</Private>
        </Text>
        <Text type="secondary">
          <span className={classname("text-number", variant)}>
            {AppUtils.convertNumber(data.dispute_count, 1)}
          </span>{" "}
          disputes
        </Text>
        <Text type="secondary">
          <span className={classname("text-number", variant)}>
            {AppUtils.convertNumber(data.transaction_count, 1)}
          </span>{" "}
          payments
        </Text>
      </Flex>
    </Flex>
  )
}

export default MonthBlock
